import React from "react";
import {
  ResponsiveContainer,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
} from "recharts";
import { fmtINR } from "../../lib/api";

export default function LazyAreaChart({ data, showInvested = false }) {
  return (
    <ResponsiveContainer width="100%" height={220}>
      <AreaChart data={data}>
        <defs>
          <linearGradient id="aw-area-grad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#10b981" stopOpacity={0.35} />
            <stop offset="100%" stopColor="#10b981" stopOpacity={0} />
          </linearGradient>
        </defs>
        <CartesianGrid
          strokeDasharray="3 3"
          vertical={false}
          stroke="rgba(148,163,184,0.18)"
        />
        <XAxis
          dataKey="year"
          tick={{ fontSize: 10 }}
          stroke="rgba(100,116,139,0.5)"
        />
        <YAxis
          tickFormatter={(v) => fmtINR(v, { compact: true })}
          tick={{ fontSize: 10 }}
          stroke="rgba(100,116,139,0.5)"
        />
        <Tooltip formatter={(v) => fmtINR(v)} />
        <Area
          type="monotone"
          dataKey="value"
          stroke="#10b981"
          strokeWidth={2.5}
          fill="url(#aw-area-grad)"
          name="Moderate (10%)"
        />
        {showInvested && (
          <Area
            type="monotone"
            dataKey="invested"
            stroke="#f59e0b"
            strokeWidth={1.5}
            fill="none"
            strokeDasharray="4 4"
            name="Conservative (6%)"
          />
        )}
      </AreaChart>
    </ResponsiveContainer>
  );
}
